import React from 'react';

export interface Tab {
  id: string;
  label: string;
  isActive: boolean;
}

interface TabNavigationProps {
  tabs: Tab[];
  onTabClick: (tabId: string) => void;
  className?: string;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  onTabClick,
  className = ''
}) => (
  <div className={`relative w-fit ${className}`}>
    <div className="flex w-fit items-center gap-8">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onTabClick(tab.id)}
          className={`
            relative flex min-w-[110px] justify-center pb-4 text-sm font-medium transition-all duration-200

            ${tab.isActive ? 'text-[#00A657]' : 'text-content'}
          `}
        >
          <span className="font-['DM_Sans']">{tab.label}</span>
          {tab.isActive && (
            <div className="absolute inset-x-0 bottom-0 h-1 bg-[#00A657]" />
          )}
        </button>
      ))}
    </div>
    <div className="absolute inset-x-0 bottom-0 h-px bg-grey30" />
  </div>
);

export default TabNavigation;
